import { Input, Component, Renderer2, ElementRef, OnInit, OnDestroy } from "@angular/core";
import { FlowTemplate } from "../../../common/models/flow.dto";
import { HeightWidthService } from "../../../common/services/height-width.service";
import { Subscription } from "rxjs";
import { getDiagramAreaHW } from "../../../common/models/height-width.model"

@Component({
    templateUrl: "./workflow-context.component.html",
    selector: "workflow-context",
    styleUrls: ["./workflow-context.component.scss"],
    standalone: false
})

export class WorkflowContextComponent implements OnInit, OnDestroy {
  public _hwSubscription: Subscription;
    @Input() template: FlowTemplate;
    @Input() showContext: boolean;

    copiedContext: string = "";
    diagramPadding: number = 0;
    editHeight: number = 0;
    editWidth: number = 0;  
    mainHeight: number = 0;
    mainWidth: number = 0;
    
    restrictedSubLevelNames: string[] = [ "value", "enabled", "visible", "notes"];
    restrictedTopLevelNames: string[] = ["domains", "organizationId", "reviewNotes"];

    constructor(
      public renderer: Renderer2,
      public el: ElementRef,
      public heightWidthService: HeightWidthService,
    ) {
        
    }

    ngOnInit(): void {
      //Get h/w from parent containers
        this._hwSubscription = this.heightWidthService.getHW().subscribe(hw => {            
        this.setContextContainerSize(hw);
      });
    }

    ngOnDestroy(): void {
      if (this._hwSubscription)
        this._hwSubscription.unsubscribe();
    }

    copyContext(value: string): void {
        this.copiedContext = value;
    }

    getRestrictedSubLevelNames(): string {
        let result = "";
        for (let n = 0; n < this.restrictedSubLevelNames.length; n++) {
            result = (result.length === 0) ? `${this.restrictedSubLevelNames[n]}` : `${result}, ${this.restrictedSubLevelNames[n]}`;
        }
        return result;
    }

    getRestrictedTopLevelNames(): string {
        let result = "";
        for (let n = 0; n < this.restrictedTopLevelNames.length; n++) {
            result = (result.length === 0) ? `${this.restrictedTopLevelNames[n]}` : `${result}, ${this.restrictedTopLevelNames[n]}`;
        }
        return result;
    }


    setContextContainerSize(hw:any): void {
      //set vars
      if (hw.mainHeight) this.mainHeight = hw.mainHeight;
      if (hw.mainWidth) this.mainWidth = hw.mainWidth;
      if (hw.diagramPadding) this.diagramPadding = hw.diagramPadding;
      if (hw.editHeight) this.editHeight = hw.editHeight;

      //are all set (from 2 different components)?
      if (this.mainHeight !== 0 && this.mainWidth !== 0 && this.editHeight !== 0 && this.diagramPadding !== 0) {

        //get new height
        let newHeight = getDiagramAreaHW(this.mainHeight, this.mainWidth, this.editHeight, this.diagramPadding);

        //resize context container
        let elContextContainer: HTMLDivElement = this.el.nativeElement.querySelector('.gojs-context-container');
        this.renderer.setStyle(elContextContainer, 'width', newHeight.width + "px");
        this.renderer.setStyle(elContextContainer, 'height', newHeight.height + "px");

        //reset values back to 0 for next resize event
        this.resetHWValues();

      }

    }
    //clears values to repeately trigger setDiagramContainerSize()
    resetHWValues() {
      this.mainHeight = 0;
      this.mainWidth = 0;
      this.editHeight = 0;
      this.diagramPadding = 0;
    }
}